import React, { Component } from 'react';
import * as actionCreators from '../../store/actions/login';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Formik, Form } from 'formik';
import { Input, Select } from '../FormGroup';
import * as Yup from 'yup';
import userService from '../../api/userService';
import Spinner from '../Spinner/Spinner';
import apiHelper from '../../api/apiHelper';
import { Button } from 'react-bootstrap';
import Dialog from '../Dialogs/Dialog';
import { api } from '../../api/client';

class ChangeSecurityQuestions extends Component {
  constructor(props) {
    super(props);
    this.onSubmitHandler = this.onSubmitHandler.bind(this);
    this.state = {
      serverError: '',
      showDialog: false,
      questions1: [],
      questions2: [],
      questions3: [],
      securityObject: {
        question1: '',
        question2: '',
        question3: '',
        answer1: '',
        answer2: '',
        answer3: ''
      },
      success: false
    };

    this.changeSecurityQuestionsSchema = Yup.object().shape({
      question1: Yup.object().required('Please select question 1'),
      question2: Yup.object().required('Please select question 2'),
      question3: Yup.object().required('Please select question 3'),
      answer1: Yup.string()
        .label('Answer 1')
        .min(3)
        .max(256)
        .required(),
      answer2: Yup.string()
        .label('Answer 2')
        .min(3)
        .max(256)
        .required(),
      answer3: Yup.string()
        .label('Answer 3')
        .min(3)
        .max(50)
        .required()
    });
  }

  async componentDidMount() {
    const me = this;
    try {
      const questions = await userService.getSecurityQuestions();
      me.setState({
        questions1: questions.questions1,
        questions2: questions.questions2,
        questions3: questions.questions3
      });
    } catch (error) {
      me.setState({ serverError: apiHelper.parseError(error) });
      console.log(error);
    }
    await this.loadAnswers();
  }

  async loadAnswers() {
    const me = this;
    try {
      const userId = me.props.CurrentUser.userId;
      const response = await api.get('users', { params: { id: userId } });
      const responseData = response.data.Data;
      var securityObject = {
        answer1: responseData.SecurityAnswer1,
        answer2: responseData.SecurityAnswer2,
        answer3: responseData.SecurityAnswer3,
        question1: me.state.questions1.find(
          f => f.value === responseData.SecurityQuestionId1
        ),
        question2: me.state.questions2.find(
          f => f.value === responseData.SecurityQuestionId2
        ),
        question3: me.state.questions3.find(
          f => f.value === responseData.SecurityQuestionId3
        )
      };
      me.setState({ securityObject });
    } catch (error) {
      me.setState({ serverError: apiHelper.parseError(error) });
      console.log(error);
    }
  }

  handleDialog() {
    this.setState({ showDialog: false });
  }

  onSubmitHandler(values, { setSubmitting, resetForm }) {
    var me = this;
    var userId = me.props.CurrentUser.userId;
    me.setState({ loading: true });

    api
      .put('users/SecurityAnswers', {
        Id: userId,
        SecurityQuestionId1: values.question1.value,
        SecurityQuestionId2: values.question2.value,
        SecurityQuestionId3: values.question3.value,
        SecurityAnswer1: values.answer1 ? values.answer1.trim() : null,
        SecurityAnswer2: values.answer2 ? values.answer2.trim() : null,
        SecurityAnswer3: values.answer3 ? values.answer3.trim() : null
      })
      .then(async () => {
        setSubmitting(false);
        await this.loadAnswers();
        resetForm(this.state.securityObject);
        me.setState({ loading: false, showDialog: true });
      })
      .catch(function(error) {
        setSubmitting(false);
        me.setState({ loading: false });
        // var a = error;
        // debugger;

        me.setState({ serverError: apiHelper.parseError(error) });
        console.log(error);
      });
  }

  render() {
    const serverError =
      this.state.serverError !== '' ? (
        <div className="errorMessage" style={{ marginBottom: 10 }}>
          {this.state.serverError}
        </div>
      ) : null;

    const spinner = this.state.loading ? <Spinner /> : null;

    const informDialog = this.state.showDialog ? (
      <Dialog
        onClose={this.handleDialog.bind(this)}
        title="Security Questions has been successfully updated."
        show={this.state.showDialog}
        closeButton="false"
        closeButtonText="OK"
      >
        <span>
          <p>
            {' '}
            All changes for Account Security Questions successfully accepted.
          </p>
        </span>
      </Dialog>
    ) : null;

    return (
      <React.Fragment>
        <Formik
          enableReinitialize
          initialValues={this.state.securityObject}
          validationSchema={this.changeSecurityQuestionsSchema}
          onSubmit={this.onSubmitHandler}
        >
          {({
            isSubmitting,
            errors
          }) => (
            <Form>
              <h2>Change Security Questions</h2>

              <Select
                name="question1"
                options={this.state.questions1}
                label="Security Question 1"
              />
              <Input name="answer1" />
              <hr />
              <Select
                name="question2"
                options={this.state.questions2}
                label="Security Question 2"
              />
              <Input name="answer2" />

              <hr />
              <Select
                name="question3"
                options={this.state.questions3}
                label="Security Question 3"
              />
              <Input name="answer3" />

              {serverError}
              {spinner}
              {informDialog}
              <div className="button-group">
                <Button
                  type="submit"
                  bsStyle="primary"
                  disabled={isSubmitting || Object.keys(errors).length > 0}
                >
                  Update
                </Button>
              </div>
            </Form>
          )}
        </Formik>
        <br />
      </React.Fragment>
    );
  }
}

export default connect(
  state => state.login,
  dispatch => bindActionCreators(actionCreators, dispatch)
)(ChangeSecurityQuestions);
